import { HistogramConfigurationProviderProps } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { HistogramPanelData } from 'features/drilldown/components/histogram/DrilldownHistogram'

const LATEST_DATA_SCHEMA_VERSION = 3

export const DEFAULT_SITE_HISTOGRAM_PANEL_DATA: HistogramPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'Site Asset Counts',
  isPinned: true,
  selectedBarIds: [],
  groupingColumn: 'site.id',
  aggregationColumn: 'unit.id',
  aggregationOperation: 'count',
}

export const SITE_HISTOGRAM_CONFIG_PROPS: HistogramConfigurationProviderProps =
  {
    defaultPanelData: DEFAULT_SITE_HISTOGRAM_PANEL_DATA,
    latestDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  }
